module.exports = __webpack_public_path__ + "static/media/Graphik-Regular.475fb1f8.woff";